import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CommonService } from './common.service';
import { ApprovalsResponse } from '../models/tank-approvals-response.interface';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TankApprovalsService extends CommonService {
  token = '';

  constructor(private httpCli: HttpClient) {
    super(httpCli);
    this.token = sessionStorage.getItem('token')!;
  }

  getApprovals(tankId: number) {
    const options = this.getHeaders(this.token);
    return this.http.get<ApprovalsResponse[]>(`${this.apiURL}/tanques/${tankId}/tank_approvals`, options);
  }

  validateNfcTag(nfc: string): Observable<any> {
    const options = this.getHeaders(this.token);
    return this.http.get<ApprovalsResponse[]>(`${this.apiURL}/tanques?tanque[folio_qr]=${nfc}`, options);
  }

}
